import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptureMathComponent } from './capture-math/capture-math.component';



@NgModule({
  declarations: [
    CaptureMathComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CaptureMathComponent
  ]
})
export class WidgetMathModule { }
